import _ from 'lodash';
import { apiFetch, apiSearch, apiRemove } from '../utility';
const apiBase = 'apIngestion';

export const search = (p = {}) => {
	const { callback = _.noop } = p;
	return (dispatch) => {
		apiSearch({
			base: apiBase,
			params: {},
			dispatch,
			callback,
		});
	};
};

export const get = ({ params, callback = _.noop }) => {
	return (dispatch) => {
		apiFetch({
			method: `${apiBase}.get`,
			params,
			dispatch,
			callback,
		});
	};
};

export const add = ({ params, callback = _.noop }) => {
	return (dispatch) => {
		apiFetch({
			method: `${apiBase}.add`,
			params,
			dispatch,
			callback,
		});
	};
};

export const update = ({ params, callback = _.noop }) => {
	return (dispatch) => {
		apiFetch({
			method: `${apiBase}.update`,
			params,
			dispatch,
			callback,
		});
	};
};

export const remove = ({ apIngestionId, callback = _.noop }) => {
	return (dispatch) => {
		apiRemove({
			base: apiBase,
			id: apIngestionId,
			dispatch,
			callback,
		});
	};
};
